import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import UserProfileMenu from '../shared/UserProfileMenu';
import LogoFull from '/TugasCoins.png';
import { useAuth } from '../../hooks/useAuth';
import { ROTAS } from '../../routes/routePaths';

const Header: React.FC = () => {
  const { usuario } = useAuth();

  const headerVariants = {
    hidden: { y: -100, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <motion.header
      className="sticky top-0 z-50 w-full bg-background text-text shadow-lg h-24"
      variants={headerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="container mx-auto flex items-center justify-between px-6 md:px-8 lg:px-10 h-24">
        <Link to={usuario !== undefined && usuario?.tipo_usuario === null ? ROTAS.DASHBOARD_CLIENTE : '/home'} className="flex items-center">
          <motion.img
            src='/clube.png'
            alt="TugasCoins Logo"
            className="h-40 object-contain"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          />
        </Link>

        <div className="flex items-center gap-4">
          {usuario ? (
            <UserProfileMenu />
          ) : (
            <Link to={ROTAS.LOGIN} className="text-primary hover:text-accent transition-colors duration-200 font-medium">
              Entrar
            </Link>
          )}
        </div>
      </div>
    </motion.header>
  );
};

export default Header;